package com.schoolconnect.app.feature.classconversations

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.AppDialogDatePickerDialog
import com.schoolconnect.app.designsystem.list.AdminListEmptyState
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListActionIcons
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminRowActionItem
import com.schoolconnect.app.designsystem.list.AdminRowActionMenu
import com.schoolconnect.app.repository.files.FileUploadRepository
import com.schoolconnect.app.downloadFile
import kotlinx.coroutines.launch
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.designsystem.list.onViewDoubleClick
import com.schoolconnect.app.feature.common.PaginationPolicy
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.datasource.network.response.ClassConversationListResponse
import com.schoolconnect.app.datasource.network.response.ClassConversationReplyResponse
import com.schoolconnect.app.datasource.network.response.ClassConversationResponse
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.lock
import ischoolconnect.sharedui.generated.resources.message
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.trash
import org.jetbrains.compose.resources.painterResource

@Composable
fun AdminClassConversationsApiScreen(
    state: ClassConversationsUiState,
    onEvent: (ClassConversationsUiEvent) -> Unit,
    shellRoleCode: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    var profileExpanded by remember { mutableStateOf(false) }
    var rowsMenuExpanded by remember { mutableStateOf(false) }
    var actionRow by remember { mutableStateOf<ClassConversationListResponse?>(null) }
    var deleteRow by remember { mutableStateOf<ClassConversationListResponse?>(null) }
    var customRangeVisible by remember { mutableStateOf(false) }
    val window = pageWindow(state.pageIndex, state.pageSize, state.totalCount)

    AdminListPageScaffold(
        title = "Conversation List & Moderation",
        subtitle = "View and moderate parent conversations across classes.",
        backgroundColor = AppBackground,
        titleColor = AppPageHeader,
        subtitleColor = AppPageSubtitle,
        headerActions = {
            ShellTopRightActions(shellRoleLabel(shellRoleCode), shellRoleSubtitle(shellRoleCode), shellAvatarInitials(shellRoleLabel(shellRoleCode)), profileExpanded, { profileExpanded = it }, onChangeRole, onLogout)
        },
        summaryCards = {},
        toolbar = {
            AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
                androidx.compose.foundation.layout.BoxWithConstraints(Modifier.fillMaxWidth().padding(16.dp)) {
                    Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.Bottom, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                        Column(Modifier.weight(1.35f), verticalArrangement = Arrangement.spacedBy(7.dp)) {
                            Text("Search by Conversation ID / Title", color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                            BoxWithConstraints(Modifier.fillMaxWidth()) {
                                AdminListSearchField(state.query, { onEvent(ClassConversationsUiEvent.QueryChanged(it)) }, "Search conversations...", width = maxWidth, modifier = Modifier.fillMaxWidth(), surfaceColor = Color.White, borderColor = AppBorder, textColor = AppNavy)
                            }
                        }
                        AppLabeledDropdownField(
                            label = "Class",
                            value = state.classSectionOptions.firstOrNull { it.id == state.classSectionId }?.label ?: "All",
                            options = state.classSectionOptions.map { it.label },
                            onSelected = { label -> state.classSectionOptions.firstOrNull { it.label == label }?.let { onEvent(ClassConversationsUiEvent.ClassSectionChanged(it.id)) } ?: onEvent(ClassConversationsUiEvent.ClassSectionChanged("")) },
                            modifier = Modifier.weight(1f),
                            allOptionLabel = "All",
                            includeAllOption = true,
                            enabled = !state.isClassSectionLoading
                        )
                        AppLabeledDropdownField(
                            label = "Period",
                            value = state.period.removeSuffix(" Time").ifBlank { "All" },
                            options = conversationPeriodOptions.map { it.removeSuffix(" Time") } + "Custom Range",
                            onSelected = { value ->
                                if (value == "Custom Range") customRangeVisible = true
                                else onEvent(ClassConversationsUiEvent.PeriodChanged(if (value == "All") CONVERSATION_PERIOD_ALL else value))
                            },
                            modifier = Modifier.weight(1f),
                            allOptionLabel = "All",
                            includeAllOption = false
                        )
                        AppOutlinedButton({ onEvent(ClassConversationsUiEvent.FiltersReset) }, Modifier.weight(.7f).height(44.dp), contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 12.dp), colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary), shape = RoundedCornerShape(8.dp)) {
                            Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(17.dp), tint = AppPrimary); Spacer(Modifier.width(6.dp)); Text("Clear", color = AppPrimary, maxLines = 1, softWrap = false)
                        }
                    }
                }
            }
        },
        table = { modifier ->
            AdminListTableCard(
                modifier = modifier,
                minContentWidth = 1180.dp,
                showVerticalScrollbar = false,
                header = {
                    AdminListSortHeaderRow(
                        listOf(
                            AdminListSortColumn("Conversation ID", 1f, state.sortField == ClassConversationsSortField.ID, state.sortAscending) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.ID)) },
                            AdminListSortColumn("Title", 1.6f, state.sortField == ClassConversationsSortField.TITLE, state.sortAscending) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.TITLE)) },
                            AdminListSortColumn("Class", .8f, state.sortField == ClassConversationsSortField.CLASS, state.sortAscending) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.CLASS)) },
                            AdminListSortColumn("Posted By", 1.8f, state.sortField == ClassConversationsSortField.POSTED_BY, state.sortAscending) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.POSTED_BY)) },
                            AdminListSortColumn("Posted On", 1.3f, state.sortField == ClassConversationsSortField.POSTED_ON, state.sortAscending) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.POSTED_ON)) },
                            AdminListSortColumn("Replies", .55f, state.sortField == ClassConversationsSortField.REPLIES, state.sortAscending, alignCenter = true) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.REPLIES)) },
                            AdminListSortColumn("Status", .8f, state.sortField == ClassConversationsSortField.STATUS, state.sortAscending) { onEvent(ClassConversationsUiEvent.SortChanged(ClassConversationsSortField.STATUS)) }
                        ),
                        actionsLabel = "Actions",
                        actionsWeight = .95f,
                        actionsAlignment = Alignment.Center
                    )
                },
                body = {
                    when {
                        state.isLoading -> AdminListTableShimmer(columns = listOf(AdminListHeaderColumn("Conversation ID", 1f), AdminListHeaderColumn("Title", 1.6f), AdminListHeaderColumn("Class", .8f), AdminListHeaderColumn("Posted By", 1.8f), AdminListHeaderColumn("Posted On", 1.3f), AdminListHeaderColumn("Replies", .55f), AdminListHeaderColumn("Status", .8f), AdminListHeaderColumn("Actions", .95f)), rowCount = state.pageSize)
                        state.errorMessage.isNotBlank() -> Box(Modifier.fillMaxWidth().weight(1f).padding(16.dp), contentAlignment = Alignment.Center) { AppDialogErrorMessage(state.errorMessage) }
                        state.rows.isEmpty() -> Box(Modifier.fillMaxWidth().weight(1f).padding(32.dp), contentAlignment = Alignment.Center) {
                            Column(horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.spacedBy(10.dp)) {
                                Icon(painterResource(Res.drawable.message), contentDescription = null, tint = AppPrimary, modifier = Modifier.size(42.dp))
                                AdminListEmptyState(
                                    title = if (state.query.isBlank()) "No conversations found" else "No conversations match your search",
                                    subtitle = if (state.query.isBlank()) "There are no parent conversations available for this school yet." else "Try a different conversation ID or title."
                                )
                                AppOutlinedButton(
                                    onClick = { onEvent(ClassConversationsUiEvent.Refresh) },
                                    modifier = Modifier.height(40.dp),
                                    contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 14.dp),
                                    colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                                    shape = RoundedCornerShape(8.dp)
                                ) {
                                    Icon(painterResource(Res.drawable.refresh_cw), null, Modifier.size(16.dp), tint = AppPrimary)
                                    Spacer(Modifier.width(6.dp))
                                    Text("Refresh conversations", color = AppPrimary)
                                }
                            }
                        }
                        else -> AdminListTableBody(items = state.rows, key = { it.id.orEmpty() }, modifier = Modifier.fillMaxWidth().weight(1f)) { row ->
                            val id = row.id.orEmpty()
                            Row(Modifier.fillMaxWidth().heightIn(min = 52.dp).padding(horizontal = 24.dp, vertical = 4.dp).onViewDoubleClick { onEvent(ClassConversationsUiEvent.ViewRequested(id)) }, verticalAlignment = Alignment.CenterVertically) {
                                AdminListTableBodyText(row.conversationCode ?: id.take(8), Modifier.weight(1f).padding(end = 8.dp), color = AppPrimary)
                                AdminListTableBodyText(row.title.orEmpty().ifBlank { "Untitled conversation" }, Modifier.weight(1.6f).padding(end = 8.dp), fontWeight = FontWeight.Medium, maxLines = 1)
                                AdminListTableBodyText(listOfNotBlank(row.className, row.sectionName).ifBlank { "—" }, Modifier.weight(.8f).padding(end = 8.dp))
                                AdminListTableBodyText(row.authorName.orEmpty().ifBlank { "—" }, Modifier.weight(1.8f).padding(end = 16.dp))
                                AdminListTableBodyText(formatConversationDate(row.postedOn ?: row.createdAt), Modifier.weight(1.3f).padding(end = 8.dp))
                                Box(Modifier.weight(.55f), contentAlignment = Alignment.Center) {
                                    AdminListTableBodyText((row.replyCount ?: 0).toString())
                                }
                                AdminListTableBodyText(row.status.orEmpty().ifBlank { "—" }, Modifier.weight(.8f).padding(end = 8.dp))
                                Box(Modifier.weight(.95f), contentAlignment = Alignment.Center) {
                                    var expanded by remember(id) { mutableStateOf(false) }
                                    AdminListActionIcons(onView = { expanded = false; onEvent(ClassConversationsUiEvent.ViewRequested(id)) }) {
                                        IconButton(onClick = { expanded = true }, modifier = Modifier.size(32.dp)) { Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = AppNavy, modifier = Modifier.size(16.dp)) }
                                        AdminRowActionMenu(
                                            sections = listOf(
                                                listOf(AdminRowActionItem("Moderate Conversation", { expanded = false; actionRow = row; onEvent(ClassConversationsUiEvent.ViewRequested(id)) }, painterResource(Res.drawable.lock))),
                                                listOf(AdminRowActionItem("Close Conversation", { expanded = false; actionRow = row; onEvent(ClassConversationsUiEvent.ViewRequested(id)) }, painterResource(Res.drawable.close_x))),
                                                listOf(AdminRowActionItem("Delete Conversation", { expanded = false; deleteRow = row }, painterResource(Res.drawable.trash), labelColor = Color(0xFFB42318), iconTint = Color(0xFFB42318)))
                                            ),
                                            onDismissRequest = { expanded = false }, expanded = expanded, width = 220.dp
                                        )
                                    }
                                }
                            }
                            HorizontalDivider(color = AppBorder)
                        }
                    }
                },
                footer = { AdminListFooter(pageText = pageFooterText(window, "conversations"), pageIndex = window.pageIndex, pageCount = window.pageCount, onPageChanged = { onEvent(ClassConversationsUiEvent.PageChanged(it)) }, pageSize = state.pageSize, rowsPerPageExpanded = rowsMenuExpanded, onRowsPerPageToggle = { rowsMenuExpanded = !rowsMenuExpanded }, onRowsPerPageDismiss = { rowsMenuExpanded = false }, onPageSizeChanged = { onEvent(ClassConversationsUiEvent.PageSizeChanged(it)) }) }
            )
        },
        bottomAction = {}
    )

    if (actionRow == null && (state.selected != null || state.isDetailLoading)) {
        ApiClassConversationViewDialog(
            detail = state.selected,
            replies = state.replies,
            isLoading = state.isDetailLoading,
            errorMessage = state.detailErrorMessage,
            isMutating = state.isMutating,
            mutationError = state.mutationErrorMessage,
            replyResetGeneration = state.replyResetGeneration,
            onDismiss = { onEvent(ClassConversationsUiEvent.ViewDismissed) },
            onReply = { text, url, filename -> state.selected?.id?.let { id -> onEvent(ClassConversationsUiEvent.ReplyRequested(id, text, url, filename)) } }
        )
    }
    if (customRangeVisible) {
        AppDialogDatePickerDialog(
            value = state.periodFrom,
            onDismiss = { customRangeVisible = false },
            onDateSelected = {},
            colors = AppDialogDefaultColors,
            dateRangeSelection = true,
            dateRangeStartValue = state.periodFrom,
            dateRangeEndValue = state.periodTo,
            onDateRangeSelected = { from, to ->
                customRangeVisible = false
                onEvent(ClassConversationsUiEvent.CustomPeriodChanged(from, to))
            }
        )
    }
    deleteRow?.let { row ->
        ConversationDeleteDialog(
            conversationId = row.id.orEmpty(),
            conversationCode = row.conversationCode ?: row.id.orEmpty(),
            title = row.title.orEmpty().ifBlank { "Conversation" },
            isMutating = state.isMutating,
            onDismiss = { if (state.isMutating != true) deleteRow = null },
            onConfirm = { reason ->
                onEvent(ClassConversationsUiEvent.DeleteRequested(row.id.orEmpty(), reason))
                deleteRow = null
            }
        )
    }
    actionRow?.let { row ->
        ModerationDialog(
            row = row,
            detail = state.selected,
            replies = state.replies,
            isLoading = state.isDetailLoading,
            isMutating = state.isMutating,
            mutationError = state.mutationErrorMessage,
            onDismiss = { actionRow = null; onEvent(ClassConversationsUiEvent.ViewDismissed) },
            onAction = { action, targetId, reason ->
                // Keep moderation mounted while a reply deletion refreshes the detail data.
                // Conversation-level actions dismiss the popup after dispatch.
                if (action != "DELETE_REPLY") actionRow = null
                onEvent(
                    if (action == "DELETE_CONVERSATION") ClassConversationsUiEvent.DeleteRequested(row.id.orEmpty(), reason)
                    else if (action == "DELETE_REPLY") ClassConversationsUiEvent.DeleteReplyRequested(row.id.orEmpty(), targetId.orEmpty(), reason)
                    else ClassConversationsUiEvent.ModerateRequested(row.id.orEmpty(), action, reason)
                )
            }
        )
    }
}

@Composable
private fun AdminConversationDialog(detail: ClassConversationResponse, replies: List<ClassConversationReplyResponse>, isLoading: Boolean, isMutating: Boolean, mutationError: String, resetGeneration: Int, onDismiss: () -> Unit, onReply: (String) -> Unit, onModerate: (String) -> Unit) {
    var reply by remember(detail.id, resetGeneration) { mutableStateOf("") }
    AppDialogScaffold(onDismiss = onDismiss, size = com.schoolconnect.app.designsystem.AppDialogSize.Wide, isLoading = isLoading || isMutating) {
        AppDialogHeader(title = detail.title.orEmpty().ifBlank { "Conversation" }, subtitle = "${detail.conversationCode ?: detail.id.orEmpty()} · ${detail.status.orEmpty()}", onClose = onDismiss, icon = Res.drawable.lock, iconContentDescription = "Conversation", colors = AppDialogDefaultColors)
        Column(Modifier.fillMaxWidth().weight(1f).padding(24.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Text(detail.description.orEmpty().ifBlank { "No description provided." }, color = AppNavy, fontSize = 14.sp)
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp), verticalAlignment = Alignment.Top) {
                Spacer(Modifier.weight(1f))
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                    ConversationDetailMetaValue("Posted By", detail.authorName.orEmpty().ifBlank { "—" }, Modifier.fillMaxWidth())
                    ConversationDetailMetaValue("Posted On", formatConversationDate(detail.postedOn ?: detail.createdAt), Modifier.fillMaxWidth())
                }
            }
            Text("Class: ${listOfNotBlank(detail.className, detail.sectionName).ifBlank { "—" }}", color = AppMuted, fontSize = 12.sp)
            Text("Replies (${replies.size})", color = AppNavy, fontWeight = FontWeight.Bold)
            replies.forEach { item ->
                Column(Modifier.fillMaxWidth().background(Color(0xFFF4F7FC), RoundedCornerShape(8.dp)).padding(10.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        Text(item.authorName.orEmpty().ifBlank { "—" }, color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 12.sp)
                        conversationAuthorRoleLabel(item.authorRole)?.let { ConversationAuthorRoleBadge(it) }
                    }
                    Text(item.replyText.orEmpty(), color = AppNavy, fontSize = 12.sp)
                    Text(formatConversationDate(item.createdAt), color = AppMuted, fontSize = 10.sp)
                }
            }
            AppDialogFieldColumn("Reply", required = true, colors = AppDialogDefaultColors) { AppDialogTextField(reply, { reply = it }, "Write a reply...", colors = AppDialogDefaultColors, singleLine = false, fieldHeight = 86.dp, maxLength = 2000) }
            if (mutationError.isNotBlank()) Text(mutationError, color = Color(0xFFB42318), fontSize = 12.sp)
        }
        AppDialogFooter(actions = listOf(AppDialogFooterAction("Close", onDismiss, width = 120.dp), AppDialogFooterAction("Post Reply", { onReply(reply); reply = "" }, AppDialogActionStyle.Primary, width = 150.dp)), colors = AppDialogDefaultColors)
    }
}

@Composable
private fun ModerationDialog(
    row: ClassConversationListResponse,
    detail: ClassConversationResponse?,
    replies: List<ClassConversationReplyResponse>,
    isLoading: Boolean,
    isMutating: Boolean,
    mutationError: String,
    onDismiss: () -> Unit,
    onAction: (String, String?, String?) -> Unit
) {
    var reason by remember(row.id) { mutableStateOf("") }
    var pendingAction by remember(row.id) { mutableStateOf<Pair<String, String?>?>(null) }
    var replyDeleteReason by remember(row.id) { mutableStateOf("") }
    var closeReason by remember(row.id) { mutableStateOf("") }
    var deleteDialogVisible by remember(row.id) { mutableStateOf(false) }
    val coroutineScope = rememberCoroutineScope()
    val isClosed = row.status.orEmpty().equals("CLOSED", true) || row.status.orEmpty().equals("Closed", true)
    AppDialogScaffold(onDismiss = onDismiss, size = com.schoolconnect.app.designsystem.AppDialogSize.Wide, dialogWidthOverride = 820.dp, maxDialogHeight = 690.dp, viewportFraction = 0.98f, fillDialogHeight = true, isLoading = isLoading || isMutating, loadingTitle = if (isMutating) "Applying moderation" else "Loading conversation") {
        AppDialogHeader(title = "Moderate Conversation", subtitle = row.conversationCode ?: row.id.orEmpty(), onClose = onDismiss, icon = Res.drawable.lock, iconContentDescription = "Moderation", colors = AppDialogDefaultColors)
        Column(Modifier.fillMaxWidth().weight(1f).verticalScroll(rememberScrollState()).padding(horizontal = 24.dp, vertical = 12.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            if (detail != null) {
                ConversationDetailMetadata(detail) { url ->
                    coroutineScope.launch {
                        FileUploadRepository.downloadBytes(url).onSuccess { bytes ->
                            downloadFile(detail.attachmentFilename.orEmpty().ifBlank { "conversation-attachment" }, bytes, "application/octet-stream")
                        }
                    }
                }
                HorizontalDivider(color = AppBorder)
                Text("Replies (${replies.size})", color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 16.sp)
                if (replies.isEmpty()) {
                    Text("No replies yet.", color = AppMuted, fontSize = 13.sp)
                } else {
                    replies.forEach { reply ->
                        Row(Modifier.fillMaxWidth().background(Color(0xFFF4F7FC), RoundedCornerShape(8.dp)).padding(10.dp), verticalAlignment = Alignment.Top, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                    Text(reply.authorName.orEmpty().ifBlank { "—" }, color = AppNavy, fontWeight = FontWeight.Bold, fontSize = 12.sp)
                                    conversationAuthorRoleLabel(reply.authorRole)?.let { ConversationAuthorRoleBadge(it) }
                                    Text("• ${formatConversationDate(reply.createdAt)}", color = AppMuted, fontSize = 10.sp)
                                }
                                Text(reply.replyText.orEmpty(), color = AppNavy, fontSize = 12.sp)
                                reply.attachmentFilename?.takeIf { it.isNotBlank() }?.let { Text("Attachment: $it", color = AppPrimary, fontSize = 11.sp) }
                            }
                            IconButton(onClick = { replyDeleteReason = ""; pendingAction = "DELETE_REPLY" to reply.id }, modifier = Modifier.size(32.dp), enabled = !isMutating) {
                                Icon(painterResource(Res.drawable.trash), "Delete reply", tint = Color(0xFFB42318), modifier = Modifier.size(16.dp))
                            }
                        }
                    }
                }
            } else {
                Text("Loading conversation details…", color = AppMuted, fontSize = 13.sp)
            }
            if (mutationError.isNotBlank()) Text(mutationError, color = Color(0xFFB42318), fontSize = 12.sp)
        }
        AppDialogFooter(actions = listOf(AppDialogFooterAction("Close", onDismiss, width = 100.dp), AppDialogFooterAction(if (isClosed) "Reopen Conversation" else "Close Conversation", { if (isClosed) pendingAction = "REOPEN" to null else { closeReason = ""; pendingAction = "CLOSE" to null } }, AppDialogActionStyle.Primary, width = 210.dp), AppDialogFooterAction("Delete Conversation", { deleteDialogVisible = true }, AppDialogActionStyle.Danger, width = 210.dp)), colors = AppDialogDefaultColors, equalWeightButtons = false)
    }
    if (deleteDialogVisible) {
        ConversationDeleteDialog(
            conversationId = row.id.orEmpty(),
            conversationCode = row.conversationCode ?: row.id.orEmpty(),
            title = detail?.title.orEmpty().ifBlank { row.conversationCode ?: row.id.orEmpty() },
            isMutating = isMutating,
            onDismiss = { if (!isMutating) deleteDialogVisible = false },
            onConfirm = { deleteReason ->
                deleteDialogVisible = false
                onAction("DELETE_CONVERSATION", null, deleteReason)
            }
        )
    }
    pendingAction?.let { (action, targetId) ->
        val isDelete = action.startsWith("DELETE")
        AppConfirmationDialog(
            onDismiss = { pendingAction = null },
            title = if (isDelete) "Confirm deletion" else if (action == "CLOSE") "Close conversation?" else "Reopen conversation?",
            subtitle = row.conversationCode ?: row.id.orEmpty(),
            bodyText = if (action == "DELETE_REPLY") "This reply will be removed from the conversation." else if (action == "DELETE_CONVERSATION") "The conversation will be deleted. This action cannot be undone." else if (action == "CLOSE") "Parents will no longer be able to add replies until it is reopened." else "The conversation will become open again.",
            confirmLabel = if (isDelete) "Delete" else if (action == "CLOSE") "Close Conversation" else "Reopen Conversation",
            tone = if (isDelete) AppConfirmationDialogTone.Danger else AppConfirmationDialogTone.Primary,
            confirmEnabled = action != "CLOSE" || closeReason.trim().isNotBlank(),
            onConfirm = { pendingAction = null; onAction(action, targetId, (if (action == "DELETE_REPLY") replyDeleteReason else if (action == "CLOSE") closeReason else reason).trim().takeIf { it.isNotBlank() }) },
            content = if (action == "DELETE_REPLY" || action == "CLOSE") {
                {
                    val value = if (action == "CLOSE") closeReason else replyDeleteReason
                    AppDialogFieldColumn("Reason", helperText = if (action == "CLOSE") "Required" else "Optional", colors = AppDialogDefaultColors) {
                        AppDialogTextField(value, { updated -> if (action == "CLOSE") closeReason = updated else replyDeleteReason = updated }, if (action == "CLOSE") "Add a reason for closing this conversation" else "Add a reason for deleting this reply", colors = AppDialogDefaultColors, singleLine = false, fieldHeight = 80.dp, maxLength = 500)
                    }
                }
            } else null
        )
    }
}

private fun listOfNotBlank(first: String?, second: String?): String = listOfNotNull(first?.trim()?.takeIf { it.isNotBlank() }, second?.trim()?.takeIf { it.isNotBlank() }).joinToString("-")
private fun formatConversationDate(value: String?): String {
    val raw = value?.trim().orEmpty()
    if (raw.isBlank()) return "—"
    val datePart = raw.substringBefore('T').substringBefore(' ')
    val parts = datePart.split('-')
    if (parts.size != 3) return raw.replace('T', ' ').take(16)
    val year = parts[0].toIntOrNull() ?: return raw.replace('T', ' ').take(16)
    val month = parts[1].toIntOrNull()?.takeIf { it in 1..12 } ?: return raw.replace('T', ' ').take(16)
    val day = parts[2].toIntOrNull() ?: return raw.replace('T', ' ').take(16)
    val monthLabel = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")[month - 1]
    val time = raw.substringAfter('T', "").take(5).takeIf { it.length == 5 }
    return buildString {
        append(day.toString().padStart(2, '0')).append(' ').append(monthLabel).append(' ').append(year)
        if (time != null) append(", ").append(time)
    }
}
